// extracted by mini-css-extract-plugin
export var container = "_23-0";